import { CESubscriptionBase } from './ce-subscription-base'


export class CESubscription extends CESubscriptionBase {

}